// CfdDetailsSection.jsx
import React from "react";
import "./CfdDetailsSection.css";
import CfdTitleHeader from "../CfdTitleHeader";
import CfdBedBathSqft from "../CfdBedBathSqft";
import CfdCountdownTimer from "../CfdCountdownTimer";
import CfdPropertyValueInfo from "../CfdPropertyValueInfo";

const CfdDetailsSection = ({
  item,
  onNavigatePDP,
  hasValidCountdown,
  activeTab,
  isModalOpen,
}) => {
  return (
    <div
      className={`col-12 ${
        isModalOpen
          ? "cfd_modal_open"
          : "col-md-4 cfd-details-container-no-modal"
      } cfd-details-container`}
    >
      <div className={`${isModalOpen ? "cfd_modal_open_details" : ""}`}>
        <CfdTitleHeader
          item={item}
          onNavigatePDP={onNavigatePDP}
          activeTab={activeTab}
        />
        <CfdBedBathSqft item={item} activeTab={activeTab} />

        {/* {!isModalOpen &&
          item?.category === "FORECLOSURE" &&
          item?.event?.eventDate && (
            <ul className="prop_details for_auction_details">
              <li className="list-inline-item">
                <a href="#" className="for_auction_text">
                  Auction:{" "}
                  {item?.event?.eventDate + ", " + item?.event?.eventTime}
                </a>
              </li>
              <li className="list-inline-item">
                <a href="#" className="for_auction_text">
                  Country: {item?.event?.venueDetails?.county}
                </a>
              </li>
            </ul>
          )} */}

        {/* {!isModalOpen && hasValidCountdown && (
          <CfdCountdownTimer
            until={item?.auctionTimeLeft / 1000}
            activeTab={activeTab}
            isModalOpen={isModalOpen}
          />
        )} */}
      </div>

      {!isModalOpen && (
        <CfdPropertyValueInfo item={item} activeTab={activeTab} />
      )}
    </div>
  );
};

export default CfdDetailsSection;
